import Model    from "./Model";

export default class SupplierPresentation extends Model
{
    constructor( options = {} )
    {
        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id        = options.id       || null;
        this.name      = options.name     || null;
        this.id        = options.id       || null;
        this.locale    = options.locale   || null;
        this.content   = options.content  || null;
    }

    toJson ()
    {
        return {
            id       : this.id,
            name     : this.name,
            locale   : this.locale,
            content  : this.content,
        }
    }

    getResume(){

        return this.content.substr(0, 100) + this.content.length > 100 ? "..." : '';
    }
}


// WEBPACK FOOTER //
// ./resources/js/models/SupplierPresentation.js